<template>
    <fragment>
        <PosterTextIndex/>
        <PosterTextAdmin/>
        <PosterTextSettings/>
        <PosterTextWooCommerce/>
        <TxProductStats/>
    </fragment>
</template>

<script>
    import PosterTextWooCommerce from "./__partials__/PosterTextWooCommerce";
    import PosterTextSettings from "./__partials__/PosterTextSettings";
    import PosterTextIndex from "./__partials__/PosterTextIndex";
    import PosterTextAdmin from "./__partials__/PosterTextAdmin";

    let layout = lovemap.vue_env;

    export default {
        name: "index",
        layout: layout,
        components: {
            PosterTextAdmin,
            PosterTextIndex,
            PosterTextSettings,
            PosterTextWooCommerce
        }
    }
</script>

<style scoped>

</style>